import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { View, Text, TouchableOpacity } from "react-native";

import { logout } from "state/modules/taker";
import { sendLoginPicture } from "state/modules/taker/operations";

import { IconButton, MediaPreview, SnackBar } from "components";
import { FILE_TYPE } from "consts/file-types";

import Camera from "./session-camera";
import Layout from "screens/common";

import { styles } from "./styles";
import { styles as qStyles } from "components/question-title/styles";

class Session extends Component {
  camera = createRef();
  state = { showCamera: false, image: "" };

  render = () => {
    return (
      <>
        <Layout
          next={this.next}
          nextDisabled={!this.state.image || !this.props.isConnected}
        >
          <TouchableOpacity
            style={styles.logout}
            onLongPress={this.props.logout}
          >
            <Text style={styles.logoutText}>Logout</Text>
          </TouchableOpacity>
          <View style={styles.container}>
            <Text style={[qStyles.questionTextStyle, styles.title]}>
              Add your picture
            </Text>
            {this.state.image
              ? this.renderPreview()
              : this.state.showCamera
              ? this.renderCamera()
              : this.renderButton()}
          </View>
        </Layout>
        {this.renderSnackBar()}
      </>
    );
  };

  next = () => {
    this.props.navigation.navigate("group");
    this.props.sendLoginPicture(this.state.image);
  };

  renderPreview = () => {
    const media = { type: FILE_TYPE.IMAGE, uri: this.state.image };
    const remove = () => this.setState({ image: "" });
    return <MediaPreview media={media} remove={remove} />;
  };

  renderCamera = () => {
    return (
      <Camera onCapture={image => this.setState({ image })}>
        <IconButton text="Take Image" icon="camera" />
      </Camera>
    );
  };

  renderButton = () => {
    return (
      <IconButton
        text="Take Image"
        onPress={() => this.setState({ showCamera: true })}
        icon="camera"
        disabled={!this.props.isConnected}
      />
    );
  };

  renderSnackBar = () => {
    if (this.props.isConnected) return <></>;
    const errorMessage = "Please connect to a network to proceed.";
    return <SnackBar message={errorMessage} />;
  };
}

const mapDispatchToProps = {
  logout,
  sendLoginPicture,
};

const mapStateToProps = state => {
  return {
    isConnected: state.network.isConnected,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Session);
